module.exports = __webpack_public_path__ + "static/assets/8323954ee0ea2b0395fc6f0ca5ba358c.svg";